import Vue from 'vue'
import Loading from '@/components/Loading'

// const components = [Loading]

// const Element = {
//   install(Vue) {
//     components.forEach((component) => {
//       Vue.component(component.name, component)
//     })
//   }
// }

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
